import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { startDragonLoad } from "./dragonAsset";

/* The landing's dragon is a 7.5MB download followed by ~450,000 points of
   surface sampling, and it used to begin only once React had mounted the
   canvas - which happened after the intro had already finished playing. Kicking
   it off here, before the first render, buys the whole length of the intro.
   Gated on the landing route so a direct load of /blog or /blog/<slug> never
   pays for a model it will not draw; arriving at the landing from there instead
   starts the load when the canvas mounts, exactly as it always did. */
if (window.location.pathname === "/") {
  startDragonLoad();
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
